import React from "react";

const PrimaryButton = ({ label, className, onClick, type, disabled, variant, loading }) => {
  const isWhiteBg = typeof className === 'string' && (className.includes('bg-white') || variant === 'outline');
  const baseBg = (disabled || loading) ? "bg-[#D9D9D9] cursor-not-allowed" : (isWhiteBg ? "" : "bg-[#00ADEF]");
  const baseText = isWhiteBg ? "" : "text-white";
  return (
    <button
      type={type ? type : "button"}
      className={`${baseBg} ${baseText} font-poppins text-center inline-flex items-center justify-center gap-2 ${className ? className : ""}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading && (
        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
      )}
      {label}
    </button>
  );
};

export default PrimaryButton;
